// These are only for demonstration purposes, some are real opportunities but most aren't
/* 
When adding an opportunity please add it to the opportunities.js file in the data folder and in the correct format below.

Type of Opportunity:
id: number
title: string
image: string (include extension (.png), it is the exact same name as the image in the public folder)
type: string
audience: string
cost: string
date: string
datenum: number
location: string
application: string
applicationLink: string
categories: string[] (SEE BELOW FOR ADDING CATEGORIES)
*/

// Category mapping
// WHEN MAKING A CATEGORY USE THE SYNTAX OF `CATEGORY[#]`
const CATEGORIES = {
  "1": "Humanities & Politics & Int. Relations",
  "2": "Speech & Debate & Model UN",
  "3": "STEM",
  "4": "Leadership/Volunteering",
  "5": "Business & Economics & Entrepreneurship",
  "6": "Law",
  "7": "Creative Expression & Team Oriented Activities",
  "8": "Summer Schools/Internships",
  "9": "Impressive Commended"
};

export default [
    {
      id: 1,
      title: "NSW Mock Trial",
      image: "nsw-mock-trial.png",
      type: "Competition (Hybrid)",
      audience: "Grade 10-11",
      cost: "Free",
      date: "March - December (Varies)",
      datenum: 3,
      location: "NSW & ACT",
      application: "Apply within the school (Term 1)",
      applicationLink: "https://www.lawsociety.com.au/Legal-Communities/High-School-Students/Mock-Trial-Competition",
      categories: [CATEGORIES[7], CATEGORIES[6]]
    },
    {
      id: 2,
      title: "Ayn Rand Institute Writing Competition",
      image: "ayn-rand.png",
      type: "Competition (Online)",
      audience: "Grade 8-12",
      cost: "Free",
      date: "July",
      datenum: 7,
      location: "Online",
      application: "Student Registration",
      applicationLink: "https://aynrand.org/students/essay-contests/",
      categories: [CATEGORIES[7], CATEGORIES[1]]
    },
    {
      id: 3,
      title: "OzCLO Linguistics Competition",
      image: "ozclo.png",
      type: "Competition (In-person)",
      audience: "Grade 7-12",
      cost: "$10",
      date: "March - July",
      datenum: 3,
      location: "Australia",
      application: "School Registration",
      applicationLink: "https://ozclo.org.au/",
      categories: [CATEGORIES[7]]
    },
    {
      id: 4,
      title: "Australian Maths Competition",
      image: 'australia-maths-challenge.png',
      type: "Competition (Hybrid)",
      audience: "Grade 3-12",
      cost: "$9",
      date: "5th - 7th August",
      datenum: 8,
      location: "Australia",
      application: "School Registration",
      applicationLink: "https://www.amt.edu.au/amc",
      categories: [CATEGORIES[3]]
    },
    {
      id: 5,
      title: "SciX@UNSW Program",
      image: "UNSW-nat-sci.png",
      type: "Summer School (In-person)",
      audience: "Grade 11-12",
      cost: "$695",
      date: "January, Apply by October",
      datenum: 1,
      location: "UNSW Sydney Randwick Campus",
      application: "Student Registration",
      applicationLink: "https://www.unsw.edu.au/science/study-with-us/scix-school-extension-program",
      categories: [CATEGORIES[3]]
    },
    {
      id: 6,
      title: "National Youth Science Forum (NYSF)",
      image: "NYSF.png",
      type: "Summer School (In-person)",
      audience: "Grade 11-12",
      cost: "$3065",
      date: "January, Apply by June",
      datenum: 1,
      location: "ANU & University of Queensland",
      application: "Student Registration",
      applicationLink: "https://www.nysf.edu.au/programs/year-12-program/",
      categories: [CATEGORIES[3]]
    },
    {
      id: 7,
      title: "Australian Training Tournament",
      image: "ATT.png",
      type: "Competition (In-person)",
      audience: "Grade 7-12",
      cost: "Varies",
      date: "Varies",
      datenum: 13,
      location: "Varies",
      application: "Invitational",
      applicationLink: "https://www.amt.edu.au/olympiad-programs",
      categories: [CATEGORIES[3]]
    },
    {
      id: 8,
      title: "School Debating (ACTDU)",
      image: "school-debating-actdu.png",
      type: "Competition (In-person)",
      audience: "Grade 7-12",
      cost: "Refer to School",
      date: "School Terms",
      datenum: 13,
      location: "Australia",
      application: "School Application",
      applicationLink: "https://www.facebook.com/ACTDU/",
      categories: [CATEGORIES[2]]
    },
    {
      id: 9,
      title: "National Schools Debating Championships (NSDC)",
      image: "debating-nsdc-trials.png",
      type: "Competition (In-person)",
      audience: "Grade 9-12",
      cost: "$700-$900",
      date: "Trials typically held in February - March",
      datenum: 2,
      location: "Varies (Host states change)",
      application: "Student Registration (Invitational)",
      applicationLink: "https://www.debating.org.au/about-nsdc",
      categories: [CATEGORIES[2]]
    },
    {
      id: 10,
      title: "International Competition for Young Debaters (Cambridge Union)",
      image: "cambridge-debating-union.png",
      type: "Competition (Hybrid)",
      audience: "Grade 10 Below",
      cost: "$220",
      date: "January",
      datenum: 1,
      location: "Australia & Cambridge UK",
      application: "Student Registration (Through Speakers' Corner)",
      applicationLink: "https://www.speakerscornerau.com/competitions",
      categories: [CATEGORIES[2]]
    },
    {
      id: 11,
      title: "Harvard World Schools",
      image: "harvard-debating-union.png",
      type: "Competition (Hybrid)",
      audience: "Grade 9-11",
      cost: "$250",
      date: "April",  
      datenum: 4,
      location: "Australia & Harvard US",
      application: "Student Registration (Through Speakers' Corner)",
      applicationLink: "https://www.speakerscornerau.com/competitions",
      categories: [CATEGORIES[2]]
    },
    {
      id: 12,
      title: "Oxford Schools ANZ",
      image: "oxford-debating-union.png",
      type: "Competition (Hybrid)",
      audience: "Grade 8-11",
      cost: "$220",
      date: "July",
      datenum: 7,
      location: "Australia & Oxford UK",
      application: "Student Registration (Through Speakers' Corner)",
      applicationLink: "https://www.speakerscornerau.com/competitions",
      categories: [CATEGORIES[2]]
    },
    {
      id: 13,
      title: "Plain English Speaking Award",
      image: "plain-english-speaking-award.png",
      type: "Competition (Hybrid)",
      audience: "Age 15+",
      cost: "$30-$60",
      date: "Varies",
      datenum: 13,
      location: "State Rounds, then Nationals",
      application: "School Registration",
      applicationLink: "https://artsunit.nsw.edu.au/program/plain-english-speaking-award",
      categories: [CATEGORIES[2]]
    },
    {
      id: 14,
      title: "UN Youth Conference",
      image: "UN-youth-conference.png",
      type: "Conference (In-Person)",
      audience: "Grade 9-12",
      cost: "$130",
      date: "May",
      datenum: 5,
      location: "State Rounds, then Nationals",
      application: "Student Registration",
      applicationLink: "https://unyouth.org.au/program/state-territory-conference/",
      categories: [CATEGORIES[2]]
    },
    {
      id: 15,
      title: "UN Youth Evatt Competition",
      image: "UN-youth-evatt-comp.png",
      type: "Competition (In-Person)",
      audience: "Grade 9-12",
      cost: "Varies",
      date: "August - September",
      datenum: 8,
      location: "State Rounds, then Nationals",
      application: "Student Registration",
      applicationLink: "https://unyouth.org.au/program/evatt-competition/",
      categories: [CATEGORIES[2]]
    },
    {
      id: 16,
      title: "UN Youth Voice Competition",
      image: "UN-youth-voice-comp.png",
      type: "Speaking Competition",
      audience: "Grade 7-10",
      cost: "Varies",
      date: "February",
      datenum: 2,
      location: "State, then National Rounds",
      application: "Online Registration",
      applicationLink: "https://unyouth.org.au/program/the-voice-competition/",
      categories: [CATEGORIES[2], "Debate & Public Speaking"]
    },
    {
      id: 17,
      title: "Global Peace Summit",
      image: "Global-peace-summit.png",
      type: "Conference (In-Person)",
      audience: "17–30 years old",
      cost: "$1,170 AUD",
      date: "January, 4 Days",
      datenum: 1,
      location: "Bangkok, Thailand",
      application: "Online Registration",
      applicationLink: "https://www.humanitarianaffairs.asia/GlobalPeaceSummit/Overview/",
      categories: [CATEGORIES[1], CATEGORIES[4]]
    },
    {
      id: 18,
      title: "John Locke Essay Competition",
      image: "john-locke-essay-comp.png",
      type: "Writing (Essay)",
      audience: "Anyone (Including Junior Section)",
      cost: "Free Entry",
      date: "Refer to Website",
      datenum: 13,
      location: "Anywhere (Online)",
      application: "Online Registration",
      applicationLink: "https://www.johnlockeinstitute.com/essay-competition",
      categories: [CATEGORIES[2], "Opportunity Spotlight"]
    },
    {
      id: 19,
      title: "UNICEF Young Ambassadors",
      image: "UNICEF-young-ambassadors.png",
      type: "Ambassador (In-Person)",
      audience: "17 - 25 yrs old",
      cost: "None",
      date: "Long-Term (1 Year)",
      datenum: 13,
      location: "Australia",
      application: "Online Registration",
      applicationLink: "",
      categories: [CATEGORIES[1]]
    },
    {
      id: 20,
      title: "Constitutional Convention",
      image: "consitutional-convention.png",
      type: "Conference (In-Person)",
      audience: "Grade 11 (In ACT)",
      cost: "None",
      date: "August, 9am-3pm",
      datenum: 8,
      location: "ACT Legislative Assembly",
      application: "Teacher Registration",
      applicationLink: "https://www.parliament.act.gov.au/visit-and-learn/learn/schools/secondary/constitutional-convention",
      categories: [CATEGORIES[1]]
    },
    {
      id: 21,
      title: "Committee Challenge",
      image: "committee-challenge.png",
      type: "Conference (In-Person)",
      audience: "Grade 7-12",
      cost: "None",
      date: "Various Dates, 9am-3pm",
      datenum: 13,
      location: "ACT Legislative Assembly",
      application: "Teacher Registration",
      applicationLink: "https://www.parliament.act.gov.au/visit-and-learn/learn/schools/secondary/committee-challenge",
      categories: [CATEGORIES[1]]
    },
    {
      id: 22,
      title: "Writing Speech to MPs",
      image: "writing-speech-to-mp.png",
      type: "Writing/Activism (Online)",
      audience: "Anyone",
      cost: "None",
      date: "Around Election times",
      datenum: 13,
      location: "Australia",
      application: "To any MP",
      applicationLink: "",
      categories: [CATEGORIES[1]]
    },
    {
      id: 23,
      title: "Ethics Olympiad",
      image: "ethics-olympiad.png",
      type: "Team Competition (Online)",
      audience: "Grade 7-12",
      datenum: 5,
      cost: "None",
      date: "May, 9am-3pm",
      location: "Online",
      application: "Teacher Registration",
      applicationLink: "https://ethicsolympiad.turbifysites.com/2026-senior-school-olympiad-page.html",
      categories: [CATEGORIES[2]]
    },
    {
      id: 24,
      title: "Philosothon",
      image: "philosothon.png",
      type: "Team Competition (In-Person)",
      audience: "Grade 7-12",
      cost: "None",
      date: "End of August",
      datenum: 8,
      location: "Online",
      application: "Teacher Registration",
      applicationLink: "https://www.philosothon.org/site/",
      categories: [CATEGORIES[2], "Debate & Public Speaking"]
    },
    {
      id: 25,
      title: "International Chemistry Quiz (ICQ)",
      image: "international-chem-quiz.png",
      type: "Competition (Online)",
      audience: "Grade 7-12",
      cost: "Varies",
      date: "Early August (Same as ASO)",
      datenum: 8,
      location: "Online",
      application: "Teacher Registration",
      applicationLink: "https://www.raci.org.au/education-outreach/school-competitions/icq",
      categories: [CATEGORIES[3]]
    },
    {
      id: 26,
      title: "Australian Science Olympiads (ASO)",
      image: 'ASO.png',
      type: "Olympiad Competition (Online)",
      audience: "Grade 7-12",
      cost: "Refer to Website (Changes for State and National Levels)",
      date: "Early August",
      datenum: 8,
      location: "State, then National Rounds",
      application: "Online Registration",
      applicationLink: "https://www.asi.edu.au/program/australian-science-olympiads/",
      categories: [CATEGORIES[3]]
    },
    {
      id: 27,
      title: "Australian Science Summer School",
      image: 'aus-science-summer-school.png',
      type: "Summer School (In-person)",
      audience: "15+ Age",
      cost: "$3000 (Depends)",
      date: "Summer Holidays (Jan)",
      datenum: 1,
      location: "Refer to Website",
      application: "Invite Only (From ASO)",
      applicationLink: "https://www.asi.edu.au/program/australian-science-olympiads/#asosummerschool",
      categories: [CATEGORIES[3], "Opportunity Spotlight"]
    },
    {
     id: 28,
    title: "Wharton Global High School Investment Competition",
    image: 'wharton-investment-competition.png',
    type: "Competition (Online)",
    audience: "Grade 8-12",
    cost: "Free",
    date: "September to May (August Registration)",
    datenum: 8,
    location: "Online, finals in University of Pennsylvania",
    application: "Online Registration",
    applicationLink: "https://globalyouth.wharton.upenn.edu/investment-competition/",
    categories: [CATEGORIES[5]]
    },
    {
      id: 29,
      title: "Harvard Crimson Case Competition",
      image: "harvard-case-comp.png",
      type: "Competition (Online)",
      audience: "Grade 7-12",
      cost: "$20",
      date: "October",
      datenum: 10,
      location: "Online",
      application: "Online Registration",
      applicationLink: "https://www.casecomp.org/",
      categories: [CATEGORIES[5]]
    },
    {
      id: 30,
      title: "Big Science Competition",
      image: "big-science-comp.png",
      type: "Competition (Online)",
      audience: "Grade 7-10",
      cost: "$10",
      datenum: 5,
      date: "May",
      location: "Online",
      application: "Teacher Registration",
      applicationLink: "https://www.asi.edu.au/program/big-science-competition/",
      categories: [CATEGORIES[3]]
    },
    {
      id: 31,
      title: "Australian Intermediate Mathematics Olympiad (AIMO)",
      image: 'australian-intermediate-maths-olympiad.png',
      type: "Competition (Online)",
      audience: "Grade 7-10",
      cost: "$25",
      datenum: 9,
      date: "September",
      location: "Online",
      application: "Teacher Registration",
      applicationLink: "https://www.amt.edu.au/aimo",
      categories: [CATEGORIES[3]]
    },
    {
      id: 32,
      title: "Bond University Mooting Competition",
      image: "mooting-comp.png",
      type: "Competition (In-person)",
      audience: "Grade 10-12",
      cost: "Free",
      datenum: 5,
      date: "May",
      location: "Online & Gold Coast",
      application: "Teacher Registration",
      applicationLink: "https://bond.edu.au/study/experience-bond-for-yourself/high-school-student-experiences/experience-a-study-area/national",
      categories: [CATEGORIES[6]]
    },
    {
      id: 33,
      title: "Australian Individual Debating and Public Speaking Championships (AIDPSC)",
      image: "aidpsc.png",
      type: "Competition (In-person)",
      audience: "High School",
      cost: "Free",
      datenum: 9,
      date: "September",
      location: "National, then International Rounds",
      application: "Teacher Registration",
      applicationLink: "https://aidpsc.com/#event-guidelines-and-descriptions",
      categories: [CATEGORIES[2]]
    },
    {
      id: 34,
      title: "Harvard Model United Nations (HMUN)",
      image: "hmun.png",
      type: "Competition (In-person)",
      audience: "High School (13+)",
      cost: "$290-500",
      datenum: 5,
      date: "May",
      location: "State, then International Rounds",
      application: "Online Application",
      applicationLink: "https://www.hmunaustralia.org/application-process",
      categories: [CATEGORIES[2]]
    },
    {
      id: 35,
      title: "National Mathematics Summer School (NMSS)",
      image: "nmss.png",
      type: "Summer School (In-person)",
      audience: "Year 11-12",
      cost: "Varies",
      datenum: 5,
      date: "January (Applications in May)",
      location: "Canberra",
      application: "Online Registration",
      applicationLink: "https://nmss.edu.au/",
      categories: [CATEGORIES[3], CATEGORIES[8]]
    },
    {
      id: 36,
      title: "International Mathematical Modelling Challenge (IMMC)",
      image: "immc.png",
      type: "Competition (Hybrid)",
      audience: "High School",
      cost: "$75 per team",
      datenum: 2,
      date: "February",
      location: "Australia, International",
      application: "Online Registration",
      applicationLink: "https://www.immchallenge.org.au/",
      categories: [CATEGORIES[3], CATEGORIES[7]]
    },
    {
      id: 37,
      title: "Young Women In Engineering (YoWIE)",
      image: "yowie.png",
      type: "Conference (In-person)",
      audience: "Year 9-12",
      cost: "Free",
      datenum: 4,
      date: "April",
      location: "Canberra",
      application: "Online Registration",
      applicationLink: "https://www.unsw.edu.au/canberra/about-us/our-schools/engineering-technology/engage-with-us/young-women-engineering",
      categories: [CATEGORIES[3]]
    },
    {
      id: 38,
      title: "Girls' Programming Network",
      image: "girls-programming.png",
      type: "Club (In-person)",
      audience: "High School",
      cost: "Varies",
      datenum: 13,
      date: "Across the Year",
      location: "Australia",
      application: "Online Registration",
      applicationLink: "https://www.girlsprogramming.network/",
      categories: [CATEGORIES[3]]
    },
    {
      id: 39,
      title: "Curious Minds",
      image: "curious-minds.png",
      type: "Internship/Mentoring (In-person)",
      audience: "Year 8-10",
      cost: "Varies",
      datenum: 13,
      date: "Across the Year",
      location: "Australia",
      application: "Online Registration",
      applicationLink: "https://curiousminds.edu.au/curious-minds-students/",
      categories: [CATEGORIES[3], CATEGORIES[8]]
    },
    {
      id: 40,
      title: "Da Vinci Decathlon",
      image: "da-vinci.png",
      type: "Competition (In-person)",
      audience: "Year 7-10",
      cost: "Varies",
      datenum: 4,
      date: "April",
      location: "State, then National Rounds",
      application: "School Registration",
      applicationLink: "https://www.davincidecathlon.com/",
      categories: [CATEGORIES[7]]
    },
    {
      id: 41,
      title: "Yale Young Global Scholars (YYGS)",
      image: "yygs.png",
      type: "Summer School (In-person)",
      audience: "Age 16-18",
      cost: "$6500 USD",
      datenum: 7,
      date: "July",
      location: "Yale University",
      application: "Online Registration. Note: Similar Summer Schools offered by other Universities exist",
      applicationLink: "https://globalscholars.yale.edu/",
      categories: [CATEGORIES[8]]
    }
  ];
